import { render, staticRenderFns } from "./AddRowModal.vue?vue&type=template&id=bd222aae&scoped=true"
import script from "./AddRowModal.vue?vue&type=script&lang=js"
export * from "./AddRowModal.vue?vue&type=script&lang=js"
import style0 from "./AddRowModal.vue?vue&type=style&index=0&id=bd222aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd222aae",
  null
  
)

export default component.exports